import { render, staticRenderFns } from "./ExamplesViewer.vue?vue&type=template&id=b8d119c0&scoped=true&lang=pug&"
import script from "./ExamplesViewer.vue?vue&type=script&lang=js&"
export * from "./ExamplesViewer.vue?vue&type=script&lang=js&"
import style0 from "./ExamplesViewer.vue?vue&type=style&index=0&id=b8d119c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d119c0",
  null
  
)

export default component.exports